export type JsonTransformResult = { ok: true; result: string } | { ok: false; error: string }
export type JsonValidationResult = { ok: true } | { ok: false; error: string }

function parseJson(input: string): { ok: true; value: unknown } | { ok: false; error: string } {
  if (!input.trim()) return { ok: false, error: 'empty' }

  try {
    return { ok: true, value: JSON.parse(input) as unknown }
  } catch (error) {
    return { ok: false, error: error instanceof Error ? error.message : String(error) }
  }
}

export function formatJson(input: string): JsonTransformResult {
  const parsed = parseJson(input)
  if (!parsed.ok) return parsed

  return { ok: true, result: JSON.stringify(parsed.value, null, 2) }
}

export function minifyJson(input: string): JsonTransformResult {
  const parsed = parseJson(input)
  if (!parsed.ok) return parsed

  return { ok: true, result: JSON.stringify(parsed.value) }
}

export function validateJson(input: string): JsonValidationResult {
  const parsed = parseJson(input)
  return parsed.ok ? { ok: true } : { ok: false, error: parsed.error }
}
